export default class CustomInputCurrencyMask {
  public static valor(value: string): string {
    let cleanedValue = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
    cleanedValue = cleanedValue.replace(/(\d+)(\d{2})$/, '$1,$2'); // Adiciona a vírgula para separar os centavos
    cleanedValue = cleanedValue.replace(/\d(?=(\d{3})+(?!\d))/g, '$&.'); // Adiciona os pontos para separar os milhares
    cleanedValue = 'R$ ' + cleanedValue; // Adiciona o símbolo de moeda (R$)
    return cleanedValue; // Retorna o valor formatado
  }

  public static valor2(value: string): string {
    // Remove todos os caracteres não numéricos
    let cleanedValue = value.replace(/\D/g, '');

    // Garante que o valor tenha ao menos 2 dígitos para centavos (se não tiver, coloca ",00")
    if (cleanedValue.length <= 2) {
      cleanedValue = '0,' + cleanedValue.padStart(2, '0');
    } else {
      // Coloca a vírgula separando os centavos
      cleanedValue = cleanedValue.replace(/(\d+)(\d{2})$/, '$1,$2');
    }

    // Adiciona os pontos para separar os milhares (após a vírgula)
    cleanedValue = cleanedValue.replace(/\d(?=(\d{3})+(?!\d))/g, '$&.');

    // Adiciona o símbolo de moeda (R$)
    cleanedValue = 'R$ ' + cleanedValue;

    return cleanedValue; // Retorna o valor formatado
  }

  public static formatarValorNumerico(value: string): string {
    
    // Adiciona os pontos para separar os milhares
    const cleanedValue = value.replace(/\d(?=(\d{3})+(?!\d))/g, '$&.');

    return cleanedValue; // Retorna o valor formatado
  }

}
